import { useAdminGet } from '@reapitform/hooks'
import { FormPreviewModel } from '../types'

export const ADMIN_FORM_PREVIEW_QUERY_KEY = ['admin-form-preview']

/**
 * Loads the like-for-like agent-view preview for a form version
 * (`GET /api/forms/{formRef}/versions/{versionRef}/preview`) — the component-factory-generated edit fields
 * for each typed review-card section, so the builder can render them exactly as the agent app does.
 */
export const useAdminFormPreview = (formReferenceID?: string, versionReferenceID?: string) => {
  const [data, loading, errorString, refresh] = useAdminGet<FormPreviewModel>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/preview`,
    retry: false,
    queryKeys: [...ADMIN_FORM_PREVIEW_QUERY_KEY, formReferenceID ?? '', versionReferenceID ?? ''],
    fetchWhenTrue: [Boolean(formReferenceID), Boolean(versionReferenceID)],
  })

  return { data, loading, errorString, refresh }
}
